import React from 'react';
import { Dropdown as BaseDropdown, DropdownProps as BaseDropdownProps } from 'antd';

export type DropdownProps = BaseDropdownProps & {};

const Dropdown: React.FC<DropdownProps> = ({ ...props }) => <BaseDropdown {...props} />;

export default Dropdown;

